<template>

    <div class="login-page">
        <div class="login-box">
            <div class="vld-parent">
                <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
            </div>

            <div class="login-logo">
                <a href="/">
                    <img src="/images/sbswhite_transp.png" alt="SBS Logo" width="100%">
                </a>
            </div>

            <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

            <div class="card">
                <div class="card-body login-card-body rounded">
                    <template v-if="step==1">
                        <p class="login-box-msg">{{$t('login.loginText')}}</p>

                        <form @submit.prevent="login">
                            <div class="input-group mb-3">
                                <input type="text" v-model.trim="$v.email.$model" class="form-control"
                                    :placeholder="$t('login.username')" :class="{ 'is-invalid': $v.email.$error }">
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-pencil-alt"></span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" v-if="!$v.email.required">
                                    {{$t('form.validation.required')}}</div>
                                <!-- <div class="invalid-feedback" v-if="!$v.email.email">
                                    {{$t('form.validation.validEmail')}}</div> -->
                            </div>

                            <div class="input-group mb-3">
                                <input :type="togglePassword ? 'text' : 'password'" v-model.trim="$v.password.$model"
                                    class="form-control" :placeholder="$t('login.password')"
                                    :class="{ 'is-invalid': $v.password.$error }">
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas" @click="togglePassword = !togglePassword"
                                            :class="togglePassword ? 'fas fa-eye-slash' : 'far fa-eye'"></span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" v-if="!$v.password.required">
                                    {{$t('form.validation.required')}}</div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button type="submit"
                                        class="btn btn-custom btn-block">{{$t('button.login')}}</button>
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-else-if="step==2">
                        <ol class="font-weight-bold p-3 text-center">
                            <li>{{$t('form.setting.scanBarcode')}}
                                <img :src="google2fa_url" :alt="$t('form.setting.googleBarcode')">
                            </li>
                            <li>{{$t('form.setting.enterPin')}}</li>
                        </ol>

                        <form @submit.prevent="enable2FA">
                            <div class="form-group">
                                <label>{{$t('form.setting.code')}}<span class="text-danger">*</span></label>
                                <b-input v-model.trim="code" required=""></b-input>
                            </div>

                            <b-button type="submit" variant="primary">{{$t('button.enable2FA')}}</b-button>
                            <b-button @click="loginSuccess" variant="default" v-if="user.google2fa_mode == 'optional'">
                                {{$t('button.skip2FA')}}</b-button>
                        </form>
                    </template>

                    <template v-else-if="step==3">
                        <p class="login-box-msg">{{$t('google2fa.heading')}}</p>

                        <form @submit.prevent="reset2FA()">
                            <div class="form-group">
                                <label>{{$t('google2fa.recoveryKey')}}</label>
                                <b-input v-model.trim="recoveryKey"></b-input>
                            </div>

                            <b-button type="submit" block class="btn-custom">{{$t('button.submit')}}</b-button>
                            <!-- <b-button @click="loginSuccess" block variant="default"
                                v-if="user.google2fa_mode == 'optional'">{{$t('button.skip2FA')}}</b-button>
                            <b-button @click="reset2FA" block>{{$t('button.reset2FA')}}</b-button> -->
                        </form>
                    </template>

                    <template v-else-if="step==4">
                        <p class="login-box-msg">{{$t('google2fa.heading')}}</p>

                        <form @submit.prevent="verifyOTP()">
                            <div class="form-group">
                                <label>{{$t('google2fa.enterPinText')}}</label>
                                <b-input v-model.trim="pin" name="one_time_password"></b-input>
                            </div>

                            <b-button type="submit" block class="btn-custom">{{$t('button.submit')}}</b-button>
                            <b-button @click="loginSuccess" block variant="default"
                                v-if="user.google2fa_mode == 'optional'">{{$t('button.skip2FA')}}</b-button>
                            <b-button @click="step = 3" block>{{$t('button.reset2FA')}}</b-button>
                        </form>
                    </template>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        required,
        email
    } from "vuelidate/lib/validators";

    export default {

        data() {
            return {
                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                email: null,
                password: null,
                username: null,

                togglePassword: false,
                step: 1,
                pin: null,
                token: null,
                google2FAEnabled: false,
                recoveryKey: null,

                user: {},
                secret: {
                    found: false,
                    enabled: false,
                },
                google2fa_url: null,
                code: null,
            }
        },

        validations: {
            email: {
                required
            },
            password: {
                required
            }
        },

        methods: {

            /**
             * Allow the user to login into system
             */
            login() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                this.clearAlert();
                this.isLoading = true;

                axios
                    .post('/login', {
                        username: this.email,
                        password: this.password
                    })
                    .then(response => {
                        this.username = response.data.data;
                        this.getToken();
                    })
                    .catch(error => {

                        let response = error.response;

                        if (response.status == 403) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.status == 422) {
                            this.showAlert(response.data.message, 'danger')
                            this.loginAttempt();
                        }

                        this.isLoading = false
                    });
            },

            /**
             * Fetch Token
             */
            async getToken() {
                let {
                    data
                } = await axios.post('/get-client', {});

                axios
                    .post("/oauth/token", {
                        username: this.username,
                        password: this.password,
                        grant_type: 'password',
                        client_id: data.id,
                        client_secret: data.secret,
                        scope: '*'
                    })
                    .then(response => {
                        if (response.data.access_token != null) {
                            this.token = response.data.access_token

                            axios.defaults.headers.common['Content-Type'] = 'application/json';
                            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;

                            this.check2FA();
                        }
                    })
                    .catch(error => {
                        this.showAlert(this.$t('login.invalid'), 'danger');
                        this.loginAttempt(false);

                        this.isLoading = false;
                    });
            },

            /**
             * Check either we need to display 2fa form or not.
             */
            async check2FA() {

                let {
                    data
                } = await axios.get('/api/user');
                if (!data.id) return;
                this.user = data;

                // Direct Login if Set in Exculde Google 2 FA Settings
                let response = await axios.get('/api/should-exclude-2fa');
                if (response.data == 1) {
                    this.loginSuccess();
                    return;
                }


                // Direct Login if Google 2FA Settings is disabled for user
                if (data.google2fa_mode != 'optional' && data.google2fa_mode != 'enforced') {
                    this.loginSuccess();
                    return;
                }


                // check password security exists and enabled by user
                if (this.user.password_security && this.user.password_security.google2fa_enable === 1) {
                    this.step = 4; // Show 2FA Verify Form - skip step 2, 3
                    this.isLoading = false;
                    return;
                }

                // Show Enable 2FA Form
                this.generateSecret();
            },

            /**
             * After successful login, redirect user to dashboard
             */
            loginSuccess() {
                localStorage.setItem('token', this.token);
                this.loginAttempt(true);
            },

            /**
             * Add login attempt into db
             */
            async loginAttempt(success = false) {
                this.user.call = success;
                this.user.username = this.username;
                let response = await axios.post('/login-failed',this.user);

                if (response.data.data.ban == 1 || success)
                    this.$router.go('/');
            },

            /**
             * Generate Google Secret Code
             */
            generateSecret() {
                this.isLoading = true;

                axios
                    .post('/api/generate2faSecret')
                    .then(response => {

                        if (response.data.success) {
                            this.secret.found = 1;
                            this.google2fa_url = response.data.data;
                            this.step = 2;
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error generating secret');

                        this.isLoading = false;
                    });
            },

            /**
             * Enable 2FA
             */
            enable2FA() {

                if (!this.code) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                this.isLoading = true;
                this.clearAlert();

                axios
                    .post('/api/2fa', {
                        verify_code: this.code
                    })
                    .then(response => {

                        if (response.data.success) {
                            alert(this.$t('login.recoveryKey', {
                                key: response.data.data
                            }))
                            this.loginSuccess();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response && error.response.status == 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    });
            },

            /**
             * Verify 2FA against current user
             */
            verifyOTP() {
                if (!this.pin) {
                    this.showAlert(this.$t('form.validation.invalidPin'), 'danger');
                    return;
                }

                this.clearAlert();
                this.isLoading = true;

                axios
                    .post('/api/verify-2fa', {
                        one_time_password: this.pin
                    })
                    .then(response => {
                        if (response.data.success)
                            this.loginSuccess();
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message[0], 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            /**
             * Reset 2FA if lost or changed device
             */
            reset2FA() {
                // valiate recovery key
                axios
                    .post('/api/reset-2fa', {
                        recovery_key: this.recoveryKey,
                        email: this.username
                    })
                    .then(response => {

                        if (response.data.success) {
                            // show scan again form
                            this.generateSecret();
                            // this.step = 2;
                        }
                    })
                    .catch(error => {
                        // console.log(error.response);
                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                    })
            },

            /**
             * Show alert
             */
            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            /**
             * Clear alert
             */
            clearAlert() {
                this.alertMessage = '';
                this.alertClass = '';
                this.alert = false;
            }
        },

        /**
         * Check if user logged in, redirect to dashboard
         */
        beforeRouteEnter(to, from, next) {
            if (localStorage.getItem('token')) {
                return next('/');
            }

            next();
        }
    }

</script>

<style scoped>
    .login-page,
    .register-page {
        background-color: #0a4fa2 !important;
    }

    .btn-custom {
        color: white;
        background: #0a4fa2;
    }

    .btn-custom:hover {
        color: white;
        background-color: #073872;
    }

</style>
